<div class="tpiq-input-search badge-input-search" [ngClass]="{'labels-input-search': !removeLabelClass}" *ngIf="allData.length > 0">
  <div class="option-picker-wrapper dropdown label-dropdown">
    <div class="wrapper-selection" *ngIf="selectedEntries.length > 0">
      <div class="badge-menu-item" *ngFor="let entry of selectedEntries" style="background-color: rgb(171, 170, 172)" (click)="removeLabel(entry)">
        <div class="item-name float-left" style="color: #FFFFFF !important;">{{entry[valueKey]}}</div>
        <i class="icon ion-close-round float-right"></i>
      </div>
    </div>
    <div class="wrapper-search">
      <input type="text" placeholder="Search..." class="input-field" (keyup)="filterEntries($event)">
    </div>
    <div class="wrapper-options" *ngIf="searchEntries.length > 0">
      <div class="badge-menu-item" [ngClass] = "{'single-row-item': displaySingleItem}" [style.color]="'#FFF'" *ngFor="let entry of searchEntries; let idx = index" (click)="triggerOnSelect($event, entry)" (mouseover)="highlightAtIndex(idx)"
           [ngClass]="{'highlight-option': highlightIndex == idx}">
        {{entry[valueKey]}}
      </div>
    </div>
  </div>
</div>

